import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';
import {
    addHelpDeskExperienceId,
    editHelpDeskExperienceId,
    viewKnowledgeResourceExperienceId,
    viewExternalLinksExperienceId,
    addProviderConnectionExperienceId,
    editProviderConnectionExperienceId,
    addExternalLinksExperienceId,
    editExternalLinksExperienceId,
    deleteProviderConnectionExperienceId,
    deleteExternalLinksExperienceId,
    viewHelpDeskExperienceId,
    deleteHelpDeskExperienceId,
} from '@atlassian/help-center-common-util/analytics/ufo/ufo';

export const viewHelpDeskPageExperience = new UFOExperience(viewHelpDeskExperienceId, {
    type: ExperienceTypes.Experience,
    performanceType: ExperiencePerformanceTypes.PageLoad,
});

export const addHelpDeskExperience = new UFOExperience(addHelpDeskExperienceId, {
    type: ExperienceTypes.Experience,
    performanceType: ExperiencePerformanceTypes.InlineResult,
});

export const editHelpDeskExperience = new UFOExperience(editHelpDeskExperienceId, {
    type: ExperienceTypes.Experience,
    performanceType: ExperiencePerformanceTypes.InlineResult,
});

export const deleteHelpDeskExperience = new UFOExperience(deleteHelpDeskExperienceId, {
    type: ExperienceTypes.Experience,
    performanceType: ExperiencePerformanceTypes.InlineResult,
});

export const viewKnowledgeResourceExperience = new UFOExperience(viewKnowledgeResourceExperienceId, {
    type: ExperienceTypes.Load,
    performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
});

export const viewExternalLinksExperience = new UFOExperience(viewExternalLinksExperienceId, {
    type: ExperienceTypes.Load,
    performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
});

export const addProviderConnectionExperience = new UFOExperience(addProviderConnectionExperienceId, {
    type: ExperienceTypes.Experience,
    performanceType: ExperiencePerformanceTypes.InlineResult,
});

export const editProviderConnectionExperience = new UFOExperience(editProviderConnectionExperienceId, {
    type: ExperienceTypes.Experience,
    performanceType: ExperiencePerformanceTypes.InlineResult,
});

export const deleteProviderConnectionExperience = new UFOExperience(deleteProviderConnectionExperienceId, {
    type: ExperienceTypes.Experience,
    performanceType: ExperiencePerformanceTypes.InlineResult,
});

export const addExternalLinksExperience = new UFOExperience(addExternalLinksExperienceId, {
    type: ExperienceTypes.Experience,
    performanceType: ExperiencePerformanceTypes.InlineResult,
});

export const editExternalLinksExperience = new UFOExperience(editExternalLinksExperienceId, {
    type: ExperienceTypes.Experience,
    performanceType: ExperiencePerformanceTypes.InlineResult,
});

export const deleteExternalLinksExperience = new UFOExperience(deleteExternalLinksExperienceId, {
    type: ExperienceTypes.Experience,
    performanceType: ExperiencePerformanceTypes.InlineResult,
});
